import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ChartComponentSettings,
    ComponentSettingsChartMeasureField,
    DatasetFieldValueType,
    NewBlockContextType,
    OrderDirection,
} from '@report-content';
import { AssocArray, YNValues } from 'tools/types';

export class BlockFactoryFunnelChart extends AbstractBlockFactory<ComponentSettingsFunnelChart> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsFunnelChart> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'funnel_chart',
                settings: {
                    uid: uid,
                    internal_name: 'funnel_chart',
                    dataQueries: {
                        table: {
                            resultFieldAggregations: {},
                            resultFields: [],
                            sort: [],
                        },
                    },
                    localPalette: {},
                    component_name: 'Funnel',
                    title: '',
                    height: 600,
                    show_in_viewer: 'Y',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    //@ts-ignore
                    value_field: datasetFields[0],
                    //@ts-ignore
                    x_field: datasetFields[0],
                    sort_field: { by_field: 'value', dir: 'DESC', value_type: 'text' },
                    groupFilter: { operator: 'AND', rules: [] },
                    display_value: 'Y',
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                    drillTo: [],
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsFunnelChart extends ChartComponentSettings {
    uid: string;
    component_name: 'Funnel';
    localPalette: AssocArray<string>;
    x_field: ComponentSettingsChartMeasureField;
    value_field: ComponentSettingsChartMeasureField;
    sort_field: { by_field: string; dir: OrderDirection; value_type: DatasetFieldValueType };
    display_value: YNValues;
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
}
